import { RolAutoridad } from './enumerations/rol-autoridad.model';

export interface IFiltroParticipacion {
  solicitudId?: string | null;
  solucionId?: string | null;
  participacionId?: string | null;
  participanteCvu?: string | null;
  participanteLogin?: string | null;
  contenedorId?: string | null;
  dependenciaId?: string | null;
  rol?: RolAutoridad | null;
  nombre?: string | null;
  fechaGeneracion?: string | null;
  like?: string | null;
}

export class FiltroParticipacion implements IFiltroParticipacion {
  constructor(
    public solicitudId?: string | null,
    public solucionId?: string | null,
    public participacionId?: string | null,
    public participanteCvu?: string | null,
    public participanteLogin?: string | null,
    public contenedorId?: string | null,
    public dependenciaId?: string | null,
    public rol?: RolAutoridad | null,
    public tipoBeca?: string | null,
    public clavePrograma?: string | null,
    public nombre?: string | null,
    public fechaGeneracion?: string | null,
    public like?: string | null
  ) {}
}
